<template>
  <div id="usage">
    <!-- 搜索 -->
    <div class="flex justify-end align-center" style="height: 32px;">
      <el-input @input='clearSear' @change='searchDev' style="width: 320px;" placeholder="请输入设备码" v-model="search" class="input-with-select">
      </el-input>
      <i @click="searchDev" style="position: absolute; right: 50px; top: 32px;color: #000000;font-size: 16px;cursor: pointer;" class="el-icon-search"></i>
    </div>
    <!-- 分界线 -->
    <div class="" style="height: 10px;background-color: #F5F6FA;width: 100%;margin-top: 16px;margin-bottom: 24px;">
    </div>

    <div class="flex flex-direction justify-between" style="min-height: 780px;">
      <div class="">
        <!-- 表格 -->
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column type="index" align="center" label="序号" width="80">
          </el-table-column>
          <el-table-column prop="ip" width='140' align="center" label="使用IP">
          </el-table-column>
          <el-table-column prop="random" align="center" label="随机数">
          </el-table-column>
          <el-table-column prop="use_time" align="center" label="在线时长">
            <template slot-scope="scope">
              <span>{{ scope.row.use_time | transforTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="open_time" align="center" label="启动时间">
          </el-table-column>
          <el-table-column prop="active_time" align="center" label="最近一次心跳">
          </el-table-column>
          <el-table-column prop="version_number" align="center" width='140' label="版本">
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <el-pagination id='pagebox' style="margin-top: 30px;text-align: center;" background
        @current-change="handleCurrentChange" :current-page="tablePage" :page-size='tableLimit'
        :page-sizes="[100, 200, 300, 400]" layout="total, prev, pager, next, jumper" :total="tableCount">
      </el-pagination>
    </div>

  </div>

</template>

<script>
  export default {
    name: 'usage',
    created() {
      this.getTable()
    },
    data() {
      return {
        currentPage4: 1,
        search: '',

        /* 获取表格数据发送参数 */
        sendData: {
          act: 'userLog',
          page: 1,
          limit: 15
        },
        /* 渲染页面参数 */
        tablePage: 1, //表格--当前页
        tableLimit: 10, //表格--当前页数据条数尺寸
        tableCount: 10, //表格--数据总条数
        tableData: [], //表格--数据列表
      }

    },
    filters: {
      /* 在线时长转换 */
      transforTime(value) {
        const hour = parseInt(value / 3600) < 10 ? '0' + parseInt(value / 3600) : parseInt(value / 3600)
        const min = parseInt(value % 3600 / 60) < 10 ? '0' + parseInt(value % 3600 / 60) : parseInt(value % 3600 / 60)
        const sec = parseInt(value % 3600 % 60) < 10 ? '0' + parseInt(value % 3600 % 60) : parseInt(value % 3600 % 60)
        let strTime = hour + '小时' + min + '分钟' + sec + '秒'
        return strTime
      },
    },
    methods: {
      /******************* 获取数据列表 */
      getTable() {
        this.$api.dataList.userTable(this.sendData).then(res => {
          // console.log(res)
          if (res.code == '1') {
            this.tablePage = res.data.page
            this.tableLimit = res.data.limit
            this.tableCount = res.data.count
            this.tableData = res.data.list
          }
        })
      },
      /******************* 切换页面  */
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.sendData.page = val
        this.getTable()
      },
      /* 搜索 */
      searchDev(){
        if(!this.search) return false
        this.$api.dataList.userTable({
          act:'userLog',
          dev:this.search
        }).then(res=>{
          // console.log('搜索：',res)
          if(res.code='1'){
            this.tablePage=res.data.page
            this.tableLimit=res.data.limit
            this.tableCount=res.data.count
            this.tableData=res.data.list
          }else{
            this.$message({
              message: res.info,
              type: 'error'
            })
          }
        })
      },
      clearSear(e){
        // console.log(e)
        if(e!='') return false
        this.sendData.page=1
        this.getTable()
      }

    }
  }
</script>

<style>
  #usage {
    background-color: #FFFFFF;
    padding: 24px;
    position: relative;
    border-radius: 6px;
  }

  #usage #pagebox {}

  /****************************/
</style>



// WEBPACK FOOTER //
// src/components/usage.vue